import React from "react"
import { Link } from "react-router-dom"
import MainMenu from "../../../Common/MainMenu"
import { srcLogo } from "../../../../images"
import styles from "./styles.module.scss"

export default function HeaderMini({ isDonateYourCard, selectedCharity }) {
  const logoAltText = (isDonateYourCard
    ? ("Donating your merchant card is powered by CharityChoice, offering over 2,500 carefully vetted charities to donate the unused balance to" +
      (selectedCharity ? `, including ${selectedCharity.CharityName}.` : "."))
    : "CharityChoice logo - number one and best charity gift card. Tax deductible  and 100% charitable.")
    
  return (
    <section className={styles.container}>
      <Link className={styles.logo} to='/'>
        <img
          src={srcLogo}
          alt={logoAltText}
          longdesc="Tax deductible Donation Gift Cards. The best charity gift a meaningful, thoughtful way of 'giving back'. Choose from causes who help with animal protection and shelters, environment, homeless, education, food banks, children, disease, research and health, disaster relief, floods, tornados, tsunamis, hurricanes, earthquakes."
        />
      </Link>
      <MainMenu barsClassName={styles.menuBars} />
    </section>
  )
}